module.exports = "<p>\n    arquivo-sia works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/arquivo-sia/arquivo-sia.component.html
// module id = ./src/app/arquivo-sia/arquivo-sia.component.html
// module chunks = main